import { InternalAxiosRequestConfig } from 'axios';

export async function addAuthorizationHeaderInterceptor(
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> {
  const { store } = await import('@core/redux/store');
  const token = store.getState().auth.token;
  if (token && config.headers) {
    config.headers.Authorization = token;
  }

  return config;
}
